{
	"awaiting_provisioning": "Awaiting",
	"columns": {
		"active_users": "Active users",
		"created_at": "Created",
		"name": "Name",
		"status": "Status",
		"usage": "Usage"
	},
	"create": "New organization",
	"deactivate": {
		"action": "Deactivate",
		"confirm": "Deactivate the organization",
		"description": "Sign-in is blocked and every open session closes, at once.",
		"intact": "Nothing is deleted: files, versions, history and the audit log stay exactly where they are.",
		"pending": "Deactivating…",
		"reversible": "The action is reversible: reactivating puts the organization back in the state it was in.",
		"success": "Organization deactivated: sign-in blocked and sessions closed.",
		"title": "Deactivate {{name}}?"
	},
	"destruction": {
		"action": "Destroy the data",
		"already_in_progress": "The destruction was already running: this request resumed it from where it had stopped.",
		"already_purged": "This organization's data had already been destroyed: nothing changed.",
		"audit_kept": "The audit stays: the record of what was done to this organization is not part of what is destroyed.",
		"available_description": "The organization is deactivated, and its data can be destroyed permanently from here: no bin, no grace period, no restore.",
		"confirm": "Destroy permanently",
		"confirm_description": "There is no way back: afterwards, none of the following can be recovered.",
		"confirm_title": "Destroy {{name}}'s data?",
		"destroys": {
			"bin": "the contents of the bin",
			"files": "every file in the organization",
			"intro": "What is destroyed:",
			"people": "the organization's people and their accounts",
			"realm": "the organization's sign-in realm",
			"versions": "every past version of every file"
		},
		"done_description": "This organization's data has been destroyed: it can't be reactivated, and the audit log stays.",
		"done_title": "Data destroyed",
		"nodes": "Files and folders removed",
		"object_versions": "Versions removed",
		"pending": "Destroying…",
		"progress_description": "The work continues in the background and can't be cancelled. Counts grow as data is removed, with no total to compute a percentage.",
		"progress_title": "Destruction in progress",
		"queued": "Destruction started. It cannot be cancelled.",
		"resume": "Resume the destruction",
		"resume_help": "If the counts have not moved for a while the destruction has stopped: resuming carries on from where it got to.",
		"resuming": "Resuming…",
		"started_at": "Ordered",
		"started_at_unknown": "Not recorded",
		"title": "Data destruction",
		"type_name_hint": "It has to match exactly, capitals and spaces included.",
		"type_name_label": "To confirm, type the organization's name",
		"type_name_mismatch": "The name you typed does not match."
	},
	"detail": {
		"attempts_label": "Provisioning attempts",
		"attempts_one": "{{count}} attempt",
		"attempts_other": "{{count}} attempts",
		"created_on": "created on {{date}}",
		"identity": {
			"description": "Name shown to people and the address used to sign in.",
			"name": "Organization name",
			"slug": "Sign-in address",
			"title": "Identity"
		},
		"last_attempt_label": "Last attempt",
		"last_attempt_never": "No attempt so far",
		"loading": "Loading the organization…",
		"more_actions": "More actions",
		"not_found_description": "This address matches no organization. It may have been destroyed, or the link is no longer valid.",
		"not_found_title": "Organization not found",
		"offline_description": "The browser is offline; the request resumes on its own once the connection is back.",
		"offline_title": "No connection",
		"provisioning": "Provisioning",
		"quota": {
			"action": "Change quota",
			"assigned": "Assigned to people",
			"back": "Back",
			"bar": "{{used}} in use, {{reserved}} assigned and not yet used, {{free}} left to assign, out of {{quota}}",
			"confirm": "Set the quota",
			"confirm_below_assigned": "People are already assigned {{assigned}}: administrators will only be able to lower assignments.",
			"confirm_below_used": "The organization already uses {{used}}: every upload will be refused until it is back under the quota.",
			"confirm_title": "Set the quota to {{quota}}?",
			"description": "Administrators split it between users.",
			"description_unlimited": "Administrators can still set a quota for each user.",
			"dialog_description": "In use now: {{used}}. Assigned to people: {{assigned}}.",
			"dialog_title": "Quota for {{name}}",
			"done": "The quota is now {{quota}}.",
			"done_unlimited": "The quota now has no limit.",
			"free": "Left to assign",
			"full": "Quota reached: every upload is refused.",
			"in_use": "In use now",
			"limit": "Quota",
			"measured": "Daily measurement, versions included",
			"near": "{{free}} left before the quota is reached.",
			"no_limit": "No limit",
			"over_assigned": "People are assigned more than the quota: administrators can only lower assignments.",
			"pending": "Saving…",
			"reserved": "Assigned, not yet used",
			"save": "Save",
			"title": "Storage",
			"too_large": "The most you can set is {{max}}."
		},
		"sections": "Sections",
		"tab_overview": "Overview",
		"view_audit": "View audit log"
	},
	"empty": {
		"description": "This instance has no customers yet. Create one to get started.",
		"no_matches_description": "No organization matches the current search or filters.",
		"no_matches_title": "No matches",
		"title": "No organizations"
	},
	"failed_step": {
		"admin_invite": "Inviting the first administrator failed.",
		"identity": "Creating the identity realm failed.",
		"storage": "Creating the storage failed."
	},
	"failure": {
		"code": "Code:",
		"no_detail": "The external system returned neither a code nor a message.",
		"repeated_one": "Provisioning has already stopped {{count}} time on the same step: retrying won't help until the cause changes.",
		"repeated_other": "Provisioning has already stopped {{count}} times on the same step: retrying won't help until the cause changes.",
		"source": {
			"admin_invite": "The invitation service's reply, verbatim:",
			"identity": "Keycloak's reply, verbatim:",
			"storage": "The storage service's reply, verbatim:",
			"unknown": "The external system's reply, verbatim:"
		},
		"step_unknown": "Creation stopped, but the step was not recorded."
	},
	"filters": {
		"status": "Status"
	},
	"form": {
		"admin_email": "Administrator email",
		"admin_email_invalid": "Enter a valid email address.",
		"admin_email_placeholder": "admin@customer.com",
		"admin_email_required": "An email address is required.",
		"back": "Back",
		"cancel": "Cancel",
		"creating": "Creating…",
		"language": "Invitation language",
		"name": "Name",
		"name_placeholder": "Acme Industries",
		"name_required": "A name is required.",
		"name_too_long": "Use at most {{max}} characters.",
		"next": "Next",
		"quota": "Storage quota",
		"quota_help": "The total storage available to the organization.",
		"quota_required": "A quota greater than zero is required.",
		"quota_too_large": "The most you can set is {{max}}.",
		"slug": "Custom URL",
		"slug_available": "This address is free.",
		"slug_checking": "Checking this address…",
		"slug_help": "Min {{min}}, max {{max}} characters. Lowercase letters, digits and single hyphens only",
		"slug_invalid": "Use lowercase letters, digits and single hyphens, {{min}} to {{max}} characters.",
		"slug_permanent": "This address is permanent and cannot be changed later.",
		"slug_placeholder": "acme-industries",
		"slug_required": "An address is required.",
		"slug_taken": "This address is already in use.",
		"step": "Step {{current}} of {{total}}",
		"submit": "Create organization",
		"title": "New organization"
	},
	"invitation": {
		"mail_down": {
			"drift": "This instance's realms point at a different mail relay than we use, so sign-in mail for its organizations isn't going out. Reapply the mail configuration to every realm. Then send the invitations again.",
			"title": "Invitations are not leaving the building",
			"unknown": "The instance reports a mail problem this screen doesn't recognize: nothing sent since then can be assumed to have arrived. Check the instance logs for the cause before resending.",
			"unreachable": "The instance can't reach its mail relay, so nothing sent while it was down has arrived. Get the relay answering, then send them again."
		},
		"resend": {
			"already_active": "Nothing was sent: this person has already activated their access.",
			"confirm": "Resend the invitation",
			"cooldown": "Resend in {{seconds}} s",
			"description": "A new email with a new activation link will be sent to this address.",
			"not_queued": "The message could not be queued for sending: nothing was sent and the previous code still works. You can try again right away.",
			"not_queued_database": "The invitation could not be saved: nothing was sent and the previous code still works. You can try again right away.",
			"not_queued_identity": "The sign-in service did not respond: nothing was sent and the previous code still works. You can try again right away.",
			"pending": "Sending…",
			"sent": "The invitation was sent again to {{email}}. The relay accepted the message; delivery is not guaranteed.",
			"supersedes": "If they already received the first email, they will need to use the new one.",
			"supersedes_title": "The previous link will stop working",
			"throttled_one": "One message a minute per address. Try again in {{count}} second.",
			"throttled_other": "One message a minute per address. Try again in {{count}} seconds.",
			"throttled_soon": "One message a minute per address. Try again shortly.",
			"title": "Resend the invitation to {{email}}?"
		}
	},
	"owners": {
		"action": "Add owner",
		"cancel": "Cancel",
		"description": "They will receive an invitation with a link to access the organization.",
		"email": "Email",
		"language": "Invitation language",
		"promote": {
			"action": "Make owner",
			"conflict": "That didn't work: the person was deactivated or removed in the meantime.",
			"done": "{{label}} is now one of the owners.",
			"pending": "Saving"
		},
		"refusal": {
			"address_taken": "This address already belongs to someone in the organization.",
			"already_invited": "This address already has an invitation waiting.",
			"already_owner": "This person is already one of the owners.",
			"deactivated": "This person is in the organization but deactivated. They can become an owner once the organization reactivates them.",
			"member": "This person is already in the organization, so no invitation is needed: you can make them an owner.",
			"rate_limited": "You wrote to this address less than a minute ago. Try again in {{seconds}} seconds."
		},
		"remove": {
			"confirm": "Remove",
			"description": "They lose access right away and are signed out on every device. To bring them back you will have to invite them again.",
			"done": "{{label}} is no longer part of the organization.",
			"pending": "Removing",
			"title": "Remove {{label}} from the organization?"
		},
		"revoke": {
			"confirm": "Remove ownership",
			"description": "They will no longer be an owner and will stay in the organization as an administrator.",
			"done": "{{label}} is no longer an owner.",
			"pending": "Saving",
			"title": "Remove {{label}} as an owner?"
		},
		"sending": "Sending",
		"sent": "Invitation sent.",
		"submit": "Send invitation",
		"title": "Invite an owner"
	},
	"page_title": "Organizations",
	"people": {
		"actions": {
			"only_owner": "You can't remove the last owner",
			"open_menu": "Open actions",
			"remove_owner": "Remove from organization",
			"resend": "Send the invitation again",
			"revoke_owner": "Remove ownership"
		},
		"actions_column": "Actions",
		"description": "Unlike other administrators, nobody in the organization can remove them, deactivate them or change their role.",
		"email_column": "Email",
		"empty": "No owner yet.",
		"invitation_column": "Invitation",
		"invitation_expired": "Expired {{date}}",
		"invitation_expires": "Expires {{date}}",
		"invitation_sent": "Sent {{date}}",
		"last_activity_column": "Last seen",
		"last_activity_never": "Never",
		"name_column": "Name",
		"no_value": "No value",
		"not_ready_description": "An organization has owners once it is running. The Overview tab says where its creation got to, or whether its data has been destroyed.",
		"not_ready_title": "No owners yet",
		"owner": "Owner",
		"role": {
			"member": "Member",
			"org_admin": "Administrator"
		},
		"role_column": "Role",
		"status": {
			"active": "Active",
			"deactivated": "Deactivated",
			"invited": "Invited",
			"removed": "Removed"
		},
		"status_column": "Status",
		"title": "Owners",
		"total_one": "{{count}} owner",
		"total_other": "{{count}} owners"
	},
	"reactivate": {
		"action": "Reactivate",
		"confirm": "Reactivate the organization",
		"description": "Sign-in reopens immediately and the organization returns to the state it was in before it was deactivated.",
		"pending": "Reactivating…",
		"sessions": "The sessions the deactivation closed do not come back: everyone who was signed in has to sign in again.",
		"success": "Organization reactivated.",
		"title": "Reactivate {{name}}?"
	},
	"retry": {
		"action": "Retry provisioning",
		"admin_email": {
			"description": "This organization stopped before the invitation step, so the first administrator's address wasn't saved: enter it again to restart provisioning.",
			"submit": "Retry with this address",
			"title": "The first administrator's address is needed"
		},
		"already_in_progress": "Provisioning is already running (somebody restarted it a moment ago, or it never stopped), so there's nothing to do but wait.",
		"pending": "Retrying…",
		"queued": "Provisioning restarted from the step it stopped on."
	},
	"search_placeholder": "Search by name",
	"status": {
		"admin_invited": "Being created",
		"failed": "Creation failed",
		"identity_ready": "Being created",
		"pending": "Being created",
		"purged": "Storage destroyed",
		"purging": "Destroying storage",
		"ready": "Active",
		"storage_ready": "Being created",
		"suspended": "Deactivated"
	},
	"step_state": {
		"active": "in progress",
		"done": "done",
		"failed": "failed",
		"pending": "not run yet"
	},
	"steps": {
		"admin_invite": "Admin invitation",
		"identity": "Identity",
		"ready": "Active",
		"storage": "Storage"
	},
	"total_one": "{{count}} organization",
	"total_other": "{{count}} organizations",
	"usage": {
		"full": "full",
		"measured_at": "Measured {{date}}",
		"near": "nearly full",
		"never_measured": "No measurement has succeeded",
		"of_quota": "{{used}} of {{quota}}",
		"stale": "Last measurement failed, figure from {{date}}",
		"unavailable": "Not available"
	}
}
